module.exports = __webpack_public_path__ + "static/1-ed029264f9ab526ffac8aa2e22478633.jpeg";